import { apiAxios } from "../apiConfig";

export const loginAdmin = async (payload) => {
  const response = await apiAxios.post("/auth/login", payload);

  return response.data;
};
